import Streaming from '../../streaming/streaming';
import {dispatchEvent} from "../../utils/eventDispatch";

/** @param {string[]|number[]} indexesId */
const connectByIndex = (indexesId) => {
    indexesId.forEach(indexId => Streaming.subscribeStockIndexByIndex(indexId, null));
};

/** @param {string|number|array} tickers */
const connectByTickers = (tickers) => Streaming.subscribeTickerIDS(tickers);

/** @param {string|number} id */
const connectByCryptoMarket = (id) => Streaming.subscribeCriptoByMarket(id, null);

/** @param {string|number} id */
const connectByForex = (id) => Streaming.subscribeForexByMarket(id, null);

/** @param {string|number} idMarket */
const connectStockByMarket = (idMarket) => Streaming.subscribeStockIndexByMarket(idMarket, null);

/**
 * Método para conectar desde el HTML a Streaming
 */
export const streamingConnector = () => {
    document.querySelectorAll('span.streaming').forEach(item => {
        const tickers = item.getAttribute('data-streaming-tickers');
        if (tickers) {
            connectByTickers(tickers);
        }

        const indexes = item.getAttribute('data-streaming-index');
        if (indexes) {
            connectByIndex(indexes.split(','));
        }

        const crypto = item.getAttribute('data-streaming-crypto');
        if (crypto) {
            connectByCryptoMarket(crypto);
        }

        const forex = item.getAttribute('data-streaming-forex');
        if (forex) {
            connectByForex(forex);
        }

        const stockByMarket = item.getAttribute('data-streaming-stockByMarket');
        if (stockByMarket) {
            connectStockByMarket(stockByMarket);
        }

        const tradingViewItem = item.getAttribute('data-streaming-tv');
        if (tradingViewItem) {
            connectForTradingView(item);
        }

        item.remove();
    });
}

/**
 *
 * @param {HTMLElement} element
 */
const connectForTradingView = (element) => {
    const tradingViewSymbol = element.getAttribute('data-symbol');
    const idTicker = element.getAttribute('data-idticker');

    if (!tradingViewSymbol || !idTicker) {
        return null;
    }

    Streaming.subscribeTickerIDS([idTicker], function(message) {
        const TVInfo = {
            time: Date.now(),
            open: parseFloat(message.open),
            high: parseFloat(message.high),
            low: parseFloat(message.low),
            close: parseFloat(message.last),
            volume: parseFloat(message.contractVol),
        };
        dispatchEvent('TVStreaming', TVInfo);
    });
}
